<template>
  <div class="container">
    <div
      class="
        error-page
        flex flex-col
        lg:flex-row
        items-center
        justify-center
        h-screen
        text-center
        lg:text-left
      "
    >
      <div class="-intro-x lg:mr-20">
        <img
          :src="require(`@/assets/images/error-illustration.svg`)"
          alt=""
          class="h-48 lg:h-auto"
        />
      </div>
      <div class="text-white mt-10 lg:mt-0">
        <div class="intro-x text-8xl font-dedium">404</div>
        <div class="intro-x text-xl lg:text-3xl font-medium mt-5">
          Oops. This page has gone missing.
        </div>
        <div class="intro-x text-lg mt-3">
          You may have mistyped the address or the page may have moved.
        </div>
        <router-link
          to="/modules/all"
          class="intro-x btn py-3 text-white border-white mt-10"
          >Back to Dashboard</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'
export default defineComponent({
  setup() {
    onMounted(() => {
      cash('body')
        .removeClass('main')
        .removeClass('login')
        .addClass('error-page')
    })
  }
})
</script>
